import React from 'react';
import Chatbot from './pages/Chatbot';

const App = () => {
  return (
    <div className="App">
      <Chatbot />
    </div>
  );
};

export default App;
